import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom'

import i18n from "i18n";

import AdminLayout from 'components/MainApp/layouts/DesktopLayout';
import styles from './SetupLocations.module.scss'

const SetupLocationsView = (props) => {
    const history = useHistory();
    const [id, setid] = useState(null);

    useEffect(() => {
        if(!props.match.params.key) return
        const id = props.match.params.key;
        setid(id)
    }, []);

    const goToAddLocation = () => {
        history.push({
            pathname: `/admin/locations/add`,
            state: {
                type: 'ZONE',
                node_code: id
            }
        })
    }

    const headerOptions = [];
    const content = <div className={styles["setup-locations-content-wrapper"]}>
        <p className={styles["setup-locations-text"]}>
            {i18n.t("can.organize.areas.sectors")}
        </p>
        <p className={styles["setup-locations-text"]}>{i18n.t("show.example.guide")}</p>
        <p className={styles["setup-locations-text"]}>{i18n.t("zone.example")}</p>
        <p className={styles["setup-locations-text"]}>{i18n.t("sector.example")}</p>
        <p className={styles["setup-locations-text"]}>{i18n.t("shelving.example")}</p>
        <p className={styles["setup-locations-text"]}>{i18n.t("level.example")}</p>


        <div className={styles["setup-locations-button"]} onClick={goToAddLocation}>{i18n.t("begin")}</div>
    </div>
    return(
        <div className={styles["setup-locations-container"]}>
        <AdminLayout
          headerTitle={i18n.t('branch.example')}
          headerOptions={headerOptions}
          content={content}
          navHidden={true}
        ></AdminLayout>
      </div>
    )
}

export default SetupLocationsView